import { render, staticRenderFns } from "./BoardAttachments.vue?vue&type=template&id=58e6f862"
import script from "./BoardAttachments.vue?vue&type=script&lang=js"
export * from "./BoardAttachments.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports